<div class="image-viewer">
  <img [src]="currentImage.downloadUrl" alt="Full image" />

  <!-- Navigation buttons -->
  <button class="btn btn-secondary nav-btn left" (click)="prev()" *ngIf="currentIndex > 0">
    <span class="material-symbols-outlined">chevron_left</span>
  </button>

  <button class="btn btn-secondary nav-btn right" (click)="next()" *ngIf="currentIndex < dialogData.images.length - 1">
    <span class="material-symbols-outlined">chevron_right</span>
  </button>

  <!-- Close button -->
  <button class="btn btn-error close-btn" (click)="close()">
    <span class="material-symbols-outlined">close</span>
  </button>
</div>
